export default __webpack_public_path__ + "static/media/Tabl_9.99ac5592.svg";